import React from "react";
import AnalyzeButton from "../../../../components/AnalyzeButton/AnalyzeButton";
import CancelButton from "../../../../components/CancelButton/CancelButton";
import { isAwaitingStoreConfirmation } from "../../../../utils/orderStatus";

export default function RowActions({
  pedido,
  setState,
  onAnalyze,
  canInlineCancel,
}) {
  if (isAwaitingStoreConfirmation(pedido)) {
    return <AnalyzeButton onClick={() => onAnalyze(pedido)} />;
  }

  if (canInlineCancel) {
    return <CancelButton pedido={pedido} setState={setState} />;
  }

  return null;
}
